import React, { useState } from 'react';
import { Outlet, useNavigate, Link as RouterLink } from 'react-router-dom';
import {
  AppBar, Toolbar, Typography, Container, Box, InputBase,
  IconButton, useTheme, alpha, Paper,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import logo from '../assets/logo-dark.png';

const PublicLayout: React.FC = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/search?q=${encodeURIComponent(searchQuery.trim())}`);
    }
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', bgcolor: '#F9F9FE' }}>
      <AppBar
        position="sticky"
        elevation={0}
        sx={{
          background: 'linear-gradient(135deg, #8459f0 0%, #6366f1 100%)',
          borderBottom: 'none',
        }}
      >
        <Toolbar sx={{ justifyContent: 'space-between', py: 0.5 }}>
          <Box
            component={RouterLink}
            to="/"
            sx={{ display: 'flex', alignItems: 'center', textDecoration: 'none', gap: 1.5 }}
          >
            <Box
              component="img"
              src={logo}
              alt="EVA"
              sx={{ height: 40, objectFit: 'cover' }}
            />
            <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 0.5 }}>
              <Typography
                variant="body1"
                sx={{
                  color: 'rgba(255,255,255,0.7)',
                  fontWeight: 400,
                  fontSize: '0.9rem',
                  letterSpacing: 0.5,
                }}
              >
                |
              </Typography>
              <Typography
                variant="h6"
                sx={{
                  color: 'white',
                  fontWeight: 600,
                  fontSize: '1.1rem',
                  letterSpacing: 0.5,
                  ml: 0.5,
                }}
              >
                Help Center
              </Typography>
            </Box>
          </Box>
          <Box component="form" onSubmit={handleSearch} sx={{ display: 'flex', alignItems: 'center' }}>
            <Paper
              elevation={0}
              sx={{
                display: 'flex',
                alignItems: 'center',
                px: 2,
                py: 0.5,
                borderRadius: 3,
                bgcolor: 'rgba(255,255,255,0.15)',
                border: '1px solid rgba(255,255,255,0.25)',
                width: { xs: 200, sm: 320 },
                '&:focus-within': {
                  bgcolor: 'rgba(255,255,255,0.25)',
                  border: '1px solid rgba(255,255,255,0.4)',
                },
              }}
            >
              <InputBase
                placeholder="Search help articles..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                sx={{
                  flex: 1,
                  fontSize: 14,
                  color: 'white',
                  '& input::placeholder': { color: 'rgba(255,255,255,0.6)', opacity: 1 },
                }}
              />
              <IconButton type="submit" size="small" sx={{ color: 'rgba(255,255,255,0.7)' }}>
                <SearchIcon fontSize="small" />
              </IconButton>
            </Paper>
          </Box>
        </Toolbar>
      </AppBar>

      <Container maxWidth="lg" sx={{ flex: 1, py: 4 }}>
        <Outlet />
      </Container>

      <Box component="footer" sx={{ py: 3, textAlign: 'center', borderTop: '1px solid #E8E8F0', bgcolor: 'white' }}>
        <Typography variant="body2" color="text.secondary">
          &copy; {new Date().getFullYear()} TipCo Automated Systems. All rights reserved.
        </Typography>
      </Box>
    </Box>
  );
};

export default PublicLayout;
